import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import BaseTypography from './core/BaseTypography';
import './design-tokens/generated/tokens.css';
import Router from './Router';
import store from './store';
import GlobalStyle from './styles/global';
import theme from './theme';
import { applyThemeModeFromUrl } from './theme-mode';

// The plan keeps dark mode out of the published site: the switch exists for dark verification on the dev server only.
if (import.meta.env.DEV) {
  applyThemeModeFromUrl(window.location.search, document.documentElement);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <BaseTypography />
    <React.StrictMode>
      <Provider store={store}>
        <Router />
      </Provider>
    </React.StrictMode>
  </ThemeProvider>,
);
